export const generateEnterKeyWatcher: (
  onEnter: () => void,
) => (e: any) => void = (onEnter: () => void) => (e: any) => {
  if (e.charCode === 13) {
    onEnter();
  }
};
